import React from 'react';

import { Text } from '@rtkwlf/c3-core-react';
import { Field, Heading, VStack } from '@rtkwlf/fenrir-react';

import { Markdown } from 'ae-components/markdown/Markdown';

import { useSecurityJourneyTranslations } from '../../../../locales/use-security-journey-translations';

type SecurityFocusDetailsProps = {
  focusGoals: string;
  focusOutcomes: string;
  isDetour: boolean;
};

export const SecurityFocusDetails: React.FC<SecurityFocusDetailsProps> = ({
  focusGoals,
  focusOutcomes,
  isDetour,
}) => {
  const { t } = useSecurityJourneyTranslations();

  const displayFocusGoals =
    focusGoals !== ''
      ? focusGoals
      : isDetour
        ? t('focusID.noGoalsForDetourMessage')
        : t('focusID.noGoalsForSecurityFocusMessage');

  const displayFocusOutcomes =
    focusOutcomes !== ''
      ? focusOutcomes
      : isDetour
        ? t('focusID.noOutcomesForDetourMessage')
        : t('focusID.noOutcomesForSecurityFocusMessage');

  return (
    <VStack gap="large" paddingBottom="medium">
      <Field.Root>
        <Field.Label>
          <Heading styledAs="heading4">{t('focusID.goals')}</Heading>
        </Field.Label>
        <Field.Content marginTop="smedium" maxWidth="prose">
          <Text size="2">{displayFocusGoals}</Text>
        </Field.Content>
      </Field.Root>
      <Field.Root>
        <Field.Label>
          <Heading styledAs="heading4">{t('focusID.outcomes')}</Heading>
        </Field.Label>
        <Field.Content marginTop="smedium" maxWidth="prose">
          <Markdown value={displayFocusOutcomes} />
        </Field.Content>
      </Field.Root>
    </VStack>
  );
};
